import enUS from "./enUS";

export default enUS;
